import {
	FormControl,
	FormHelperText,
	HStack,
	Text,
	VStack,
	InputGroup,
	InputRightElement,
	IconButton,
	Heading,
	Image,
	Link,
	Icon,
} from '@chakra-ui/react'
import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import 'react-phone-input-2/lib/style.css'
import { useValidateOtp } from '../../../hooks/login.hooks'
import { GoEyeClosed, GoEye } from 'react-icons/go'
import { BsPhoneVibrate } from 'react-icons/bs'
import greneLogo from '../../../assets/images/grene-logo.png'
import {
	AUTH_LOGIN_MODE,
	AUTH_SESSION_CHECK,
	AUTH_SESSION_DATA,
} from '../../../utils/constant'
import { useSendCognitoOtp } from './../../../hooks/login.hooks'
import { LS_LOGIN_MODE } from '../login.util'
import { useAuthContext } from './../../../context/auth.context'
import { TfiEmail } from 'react-icons/tfi'
import { loginConst } from './../../../utils/action.constant'
import InputText from './../../globalComponents/inputText/index'
import { Box } from '@chakra-ui/layout'
import { LOGIN_MODE } from './../login.util'
import ButtonCTA from './../../globalComponents/button/index'
import SVGIcon from '../../../assets/svgIcons'

export default function ActiveDirectoryInput({
	onValidationSuccess,
	setLoginMode,
}) {
	const {
		handleSubmit,
		register,
		formState: { errors },
	} = useForm()
	const {
		mutate: mutateValidatePassword,
		isLoading,
		isError: errorPassword,
	} = useValidateOtp()
	const { dispatch } = useAuthContext()

	const {
		mutate: mutateValidateUsername,
		isLoading: isSending,
		isError: errorUser,
	} = useSendCognitoOtp()

	const [showPassword, setShowPassword] = useState(false)
	const handleClick = () => setShowPassword(!showPassword)

	const onValidatePassword = (userInfo, password) => {
		const encodedPassword = Buffer.from(password).toString('base64')
		mutateValidatePassword(
			{ user: userInfo, otp: encodedPassword },
			{
				onSuccess: async userToken => {
					sessionStorage.setItem(
						AUTH_LOGIN_MODE,
						LS_LOGIN_MODE.ACTIVE_DIRECTORY
					)
					sessionStorage.setItem(AUTH_SESSION_DATA, JSON.stringify(userToken))
					sessionStorage.setItem(AUTH_SESSION_CHECK, true)
					dispatch({
						type: loginConst.LOGIN,
						payload: {
							...userToken,
						},
					})
					onValidationSuccess()
				},
			}
		)
	}

	const onLogin = async data => {
		const { email, password } = data

		mutateValidateUsername(
			{ email },
			{
				onSuccess: userInfo => {
					onValidatePassword(userInfo, password)
				},
			}
		)
	}

	return (
		<>
			<Heading fontWeight='900' fontSize='1.625rem' lineHeight='2.25rem'>
				Login Using Active Directory
			</Heading>
			<Text fontWeight='500' fontSize='1rem' lineHeight='1.375rem'>
				Login using your Email ID and Password
			</Text>
			<form onSubmit={handleSubmit(onLogin)}>
				<VStack minH='5rem' minW='22rem' spacing={4} justifyContent='center'>
					<FormControl id='email' pt={2} borderRadius='sm'>
						<InputText
							fontWeight='400'
							fontSize='1.125rem'
							lineHeight='1.5rem'
							placeholder='Enter your email'
							borderRadius='0'
							border='none'
							borderBottom='1px solid #D9D9D9'
							variant='noOutlineInput'
							_placeholder={{
								color: '#B1B1B1',
							}}
							inputref={register('email', {
								pattern: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
								required: true,
							})}
						/>
						{errors && errors['email'] && (
							<FormHelperText color='red.600' fontWeight='400' fontSize='sm'>
								Please provide valid email
							</FormHelperText>
						)}
					</FormControl>
					<FormControl>
						<InputGroup size='md'>
							<InputText
								fontWeight='400'
								fontSize='1.125rem'
								lineHeight='1.5rem'
								borderRadius='0'
								border='none'
								borderBottom='1px solid #D9D9D9'
								variant='noOutlineInput'
								_placeholder={{
									color: '#B1B1B1',
								}}
								type={showPassword ? 'text' : 'password'}
								placeholder='Enter your password'
								inputref={register('password', {
									required: true,
								})}
							/>
							<InputRightElement size='sm'>
								<IconButton
									size='sm'
									color='brand.700'
									aria-label='Toggle Password Visibility'
									icon={showPassword ? <GoEye /> : <GoEyeClosed />}
									onClick={handleClick}
								/>
							</InputRightElement>
						</InputGroup>
						{errors && errors['password'] && (
							<FormHelperText color='red.600' fontWeight='400' fontSize='sm'>
								Please provide valid password
							</FormHelperText>
						)}
					</FormControl>
					<HStack alignItems='center'>
						<ButtonCTA
							mt={4}
							type='submit'
							bg='brand.800'
							color='#828282'
							size='md'
							minW='200px'
							borderRadius='22px'
							background='gray.600'
							border='1px solid #D9D9D9'
							_hover={{
								color: 'white',
								background:
									'linear-gradient(268.34deg, #139988 10.16%, #008A4B 102.89%)',
							}}
							fontWeight='900'
							fontSize='1rem'
							lineHeight='1.375rem'
							disabled={!!isLoading || !!isSending}
						>
							{isLoading || isSending ? 'Please, wait...' : 'Login'}
						</ButtonCTA>
					</HStack>
					{errorUser && (
						<Text color='red.600' fontWeight='400' fontSize='sm'>
							No user found!
						</Text>
					)}
					{errorPassword && (
						<Text color='red.600' fontWeight='400' fontSize='sm'>
							Incorrect username or password
						</Text>
					)}
				</VStack>
			</form>
			<Box>
				<Link
					fontSize='0.875rem'
					variant='string'
					lineHeight='2.25rem'
					fontWeight='900'
					color='brand.700'
					display='flex'
					alignItems='center'
					onClick={() => {
						setLoginMode(LOGIN_MODE.QR)
					}}
				>
					{/* <Image src={greneLogo} maxW="1.375rem" mr={4} /> */}
					<Box mr={4}>
						<SVGIcon
							iconName='greenlogoSvg'
							svgProps={{
								width: '20',
								height: '19',
								viewBox: '0 0 20 19',
							}}
							pathProps={{ fill: '#009B76' }}
						/>
					</Box>
					Login using GRID App
				</Link>
				<Link
					fontSize='0.875rem'
					variant='string'
					lineHeight='2.25rem'
					fontWeight='900'
					color='brand.700'
					display='flex'
					alignItems='center'
					onClick={() => {
						setLoginMode(LOGIN_MODE.OTP)
					}}
				>
					<Icon as={BsPhoneVibrate} mr={4} w='1.375rem' h='1.375rem' />
					Login using Phone
				</Link>
				<Link
					fontSize='0.875rem'
					variant='string'
					lineHeight='2.25rem'
					fontWeight='900'
					color='brand.700'
					display='flex'
					alignItems='center'
					onClick={() => {
						setLoginMode(LOGIN_MODE.EMAIL)
					}}
				>
					<Icon as={TfiEmail} mr={4} w='1.375rem' h='1.375rem' />
					Login using Email
				</Link>
			</Box>
		</>
	)
}
